import {styled} from '@mui/material/styles'
import {Typography} from '@mui/material'

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.body.fontSize.xs,
  color: theme.palette.common.black
}))
